<template>
<modal :show="show" :isSmall="true" @close="close">
    <div class="modal-header border-0">
        <h5 class="modal-title">{{title}}</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body p-4 overflow-auto">
        {{message}}
    </div>

    <div class="modal-footer justify-content-start border-0">
        <button class="btn btn-outline-primary btn-sm" @click="confirm">
            {{confirmText}}
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
export default {

    name: 'MessageModal',

    props: {
        title: '',
        message: '',
		confirmText: {
			type: String,
			default: "OK"
		},
    },

    components: {
        Modal
    },

    data(){
        return {
            show:false
        }
    },

    methods: {
        open(){
            this.show=true;
        },

        close(){
            this.show=false;
			this.$emit('close');
        },

        confirm() {
            this.show=false;
			this.$emit('confirm');
        }
    }

}
</script>
